module.exports = __webpack_public_path__ + "prod/1.42.2/img/batch_launch_display.098f57a5.png";